import { render, staticRenderFns } from "./Insights.vue?vue&type=template&id=d05a3dd2&scoped=true"
import script from "./Insights.vue?vue&type=script&lang=js"
export * from "./Insights.vue?vue&type=script&lang=js"
import style0 from "./Insights.vue?vue&type=style&index=0&id=d05a3dd2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d05a3dd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/data/workspace/KCC_AUDIT_PROD_Frontend/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d05a3dd2')) {
      api.createRecord('d05a3dd2', component.options)
    } else {
      api.reload('d05a3dd2', component.options)
    }
    module.hot.accept("./Insights.vue?vue&type=template&id=d05a3dd2&scoped=true", function () {
      api.rerender('d05a3dd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/businessHome/components/ClientUserWrap/Insights.vue"
export default component.exports